import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t } from '../../i18n/translate.js';
import Input from '../../components/Input/Input.js';
import { PHONE_MAX_LENGTH } from '../../services/appConstants/appConstants.js';
import { isPhoneNumberValid } from '../../services/utilities/validation.js';
import { cleanPhoneNumber } from '../../services/utilities/phoneNumberUtil.js';
import styles from './PhoneNumberForm.module.scss.js';

function PhoneNumberForm(_ref) {
  var phoneNumber = _ref.phoneNumber,
    onPhoneNumberValidated = _ref.onPhoneNumberValidated,
    onPhoneNumberUpdated = _ref.onPhoneNumberUpdated,
    placeholder = _ref.placeholder,
    mandatory = _ref.mandatory,
    saveError = _ref.saveError,
    dataTestId = _ref.dataTestId;
  var _useState = useState(phoneNumber),
    _useState2 = _slicedToArray(_useState, 2),
    newInstallationAddressPhone = _useState2[0],
    setNewInstallationAddressPhone = _useState2[1];
  var emptyWhenNotMandatory = function emptyWhenNotMandatory(number) {
    return number === '' && !mandatory;
  };
  var phoneError = function phoneError(number) {
    return Boolean(!emptyWhenNotMandatory(number) && !isPhoneNumberValid(number));
  };
  var onChange = function onChange(value) {
    var cleanPhone = cleanPhoneNumber(value);
    setNewInstallationAddressPhone(cleanPhone);
  };
  useEffect(function () {
    onPhoneNumberValidated(!phoneError(newInstallationAddressPhone));
    onPhoneNumberUpdated(newInstallationAddressPhone);
  }, [newInstallationAddressPhone]);
  useEffect(function () {
    setNewInstallationAddressPhone(phoneNumber);
  }, [phoneNumber]);
  var phoneErrorMsg = function phoneErrorMsg() {
    if (mandatory && !newInstallationAddressPhone) {
      return t('MPLIB_SYSTEM_SETTINGS_PHONE_NUMBER_CAN_NOT_BE_EMPTY');
    }
    if (phoneError(newInstallationAddressPhone)) {
      return t('MPLIB_SYSTEM_SETTINGS_INVALID_PHONE_NUMBER');
    }
    if (saveError) {
      return saveError;
    }
    return '';
  };
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Input, {
    onChange: onChange,
    maxLength: PHONE_MAX_LENGTH,
    placeholder: placeholder,
    value: newInstallationAddressPhone || '',
    dataTestId: dataTestId,
    hasError: phoneError(newInstallationAddressPhone),
    errorMessage: phoneErrorMsg(),
    mandatory: mandatory,
    icon: mandatory ? '' : 'icon-trash-bin',
    className: styles.nobottom,
    onIconClick: mandatory ? function () {} : function () {
      setNewInstallationAddressPhone('');
    }
  }));
}
PhoneNumberForm.propTypes = {
  phoneNumber: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onPhoneNumberValidated: PropTypes.func,
  onPhoneNumberUpdated: PropTypes.func,
  mandatory: PropTypes.bool,
  saveError: PropTypes.string,
  dataTestId: PropTypes.string
};
PhoneNumberForm.defaultProps = {
  phoneNumber: '',
  onPhoneNumberValidated: function onPhoneNumberValidated() {},
  onPhoneNumberUpdated: function onPhoneNumberUpdated() {},
  mandatory: true,
  saveError: '',
  dataTestId: ''
};

export { PhoneNumberForm as default };
